import { useEffect } from "react";
import style from "./mobile.module.scss";
import MobileStep1 from "./MobileStep1";
import MobileStep2 from "./MobileStep2";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  order: Order;
  step: number;
  setStep: (step: number) => void;
};

const MobileInfo = (props: Props) => {
  const { order, step, setStep } = props;
  const { t } = useTranslation();
  useEffect(() => {
    if (window.localStorage.getItem("step")) {
      setStep(1);
      window.localStorage.removeItem("step");
    }

    const handlePageLoad = () => {
      if (window.localStorage.getItem("step")) {
        window.localStorage.removeItem("step");
        setStep(0);
      }
    };
    window.addEventListener("load", handlePageLoad);
    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, []);

  //   useEffect(() => {
  //     const handlePopState = (event) => {
  //       if (step == 1) {
  //         // 阻止默认行为
  //         event.preventDefault();
  //         window.location.reload();
  //         setStep(0);
  //       }
  //     };

  //     // 添加事件监听器
  //     window.addEventListener("popstate", handlePopState, false);
  //     return () => {
  //       window.removeEventListener("popstate", handlePopState);
  //     };
  //   }, [step]);

  return (
    <>
      <div className={style["mobile-content"]}>
        <MobileStep1 order={order} step={step} />
        <MobileStep2 order={order} setStep={setStep} step={step} />
        {step === 0 && (
          <div className={style.fixed_bottom_area}>
            <Button
              className={style.bottom_btn}
              onClick={() => setStep(1)}
              type="primary"
            >
              {t("确认订单，下一步")}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileInfo;
